import React from 'react'
import { Typography, Skeleton } from 'antd';

const { Title } = Typography;

const titleStyle = {
    color: "white",
    margin:"80px"
}

function About() {
  return (
    <div>
        <Title level={1} style={titleStyle}>About</Title>
        <div style={{display:"flex", flexDirection:"column", justifyContent:"center", width:"50%", margin:"auto", marginBottom:"100px"}}>
            <Skeleton active />
            <Skeleton active />
            <Skeleton active />
        </div>
    </div>
  )
}

export default About